import React, { useState } from 'react';
import { Input, Popover } from 'antd';

function FeaturedCatSingle({imageValue, imageText, imageLink, updateImage, updateText, updateLink}) {
  const tooltip = (
    <div>
      <span>To accomplish the same effect as the demo store, please use these dimensions.</span><br/><br/>
      <span>You can have taller images but it is recommended to make all images the same height.</span>
    </div>
  );

  return(
    <>
      <label>
        <span>Image&nbsp;
          <Popover content={tooltip}>
            <a href="javascript:void(0)">(Width: 385px - Height: 220px)</a>
          </Popover>
        </span>
        <Input type="text" value={imageValue} onChange={(evt) => updateImage(evt.target.value)} />
      </label>
      <label>
        <span>Text</span>
        <Input type="text" value={imageText} onChange={(evt) => updateText(evt.target.value)} />
      </label>
      <label>
        <span>Link</span>
        <Input type="text" value={imageLink} onChange={(evt) => updateLink(evt.target.value)} />
      </label>
    </>
  )
}

export default FeaturedCatSingle;
